/**
 * 表情包管理页懒加载壳（14.17b；VlistDemoLazy 同构）：列表/创建两页同在
 * StickerPacksPage 模块里动态 import，低频管理页不进首屏 bundle。
 * packId：undefined=我的表情包列表；0=创建；>0=修改。
 */
import { useLazyModule } from './useLazyModule';

export function StickerPacksLazy({ packId }: { packId?: number }) {
  const { mod } = useLazyModule(() => import('./StickerPacksPage'));
  if (mod === null) return <div data-testid="sticker-packs-loading-shell">加载中…</div>;
  return packId === undefined ? (
    <mod.StickerPacksListPage />
  ) : (
    <mod.StickerPackEditPage packId={packId} />
  );
}
